import React, { useState, useEffect } from "react";
import mainCourses from "./courses";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { RiStarFill, RiStarHalfFill } from "react-icons/ri";
import { BsCartFill } from "react-icons/bs";
import {Link} from 'react-router-dom'

const CourseDisplay = () => {
  const [isLoading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [counter, setCounter] = useState(0);

  const displayCourses = () => {
    setCourses(mainCourses);
    setLoading(false);
  };

  useEffect(() => {
    displayCourses();
  }, []);

  if (isLoading) {
    return (
      <>
        <div className="loading-component">
          <h3>Loading data</h3>
        </div>
      </>
    );
  }

  const { id, data, desc, writeUp } = courses[counter];

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 8,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <section className="tab-section">
        <div className="title">
          <h2>A broad selection of courses</h2>
        </div>
        <div className="paragraph">
          <p>
            Choose from 213,000 online video courses with new additions
            published every month
          </p>
        </div>
        <div className="courses-center">
          <div className="courses-container">
            {courses.map((course, index) => {
              return (
                <>
                  <div className="tab-btn-container">
                    <button
                      className={
                        index === counter ? "active-tab-btn" : "tab-btn"
                      }
                      key={course.id}
                      onClick={() => setCounter(index)}
                    >
                      {course.subject}
                    </button>
                  </div>

                  {/* Course Data info */}
                </>
              );
            })}
          </div>
          <div>
            <div className="course-info">
              <div className="course-wrapper">
                <div className="course-wrapper-analysis">
                  <h2>{desc}</h2>
                  <p>{writeUp}</p>
                  <button className="explore-btn">Explore Python</button>
                </div>
                <Carousel showDots={true} responsive={responsive}>
                  {data.map((item, index) => {
                    return (
                      <>
                      <Link to={`courses/${id}`}>
                      <div className="data-display-container" key={index}>
                          <img
                            src={item.image}
                            alt={item.title}
                            className="carousel-img"
                          />
                          <div className="title-header">
                            <h4>{`${item.title.substring(0, 35)}...`}</h4>
                          </div>

                          <h5>{item.author}</h5>
                          <div className="ratings">
                            <h5>{item.ratings}</h5>
                            <div className="stars">
                              <RiStarFill />
                              <RiStarFill />
                              <RiStarFill />
                              <RiStarFill />
                              <RiStarHalfFill />
                            </div>
                            <h6 style={{ color: "black" }}>
                              ({item.numOfStudents})
                            </h6>
                          </div>
                          <div className="cost">
                            <h3>&#8358;{item.cost}</h3>
                            <s className="prev-cost">&#8358;{item.prevCost}</s>
                          </div>
                          {item.bestSeller ? (
                            <h4 className="best-seller">Best Seller</h4>
                          ) : null}
                          <div className="cart">
                            <button className="cart-btn" style={{cursor:'pointer'}}>
                              <BsCartFill />
                              Add To Cart
                            </button>
                          </div>
                        </div>

                      </Link>

                      </>
                    );
                  })}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CourseDisplay;
